import React from 'react';
import {
  FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const NewOnboardingCapacityItem = ({ submitNewOnboardingCapacityItem, submitting }) => {
  return (
    <FDStack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'center'}>
      <MetaControlField attr={'startDate'} />
      <MetaControlField attr={'endDate'} />
      <MetaControlField attr={'capacity'} />
      <FDPrimaryActionButton
        icon={'add'}
        label={'Add'}
        size={'sm'}
        onClick={submitNewOnboardingCapacityItem}
        disabled={submitting}
      />
    </FDStack>
  );
};


export default NewOnboardingCapacityItem;
